import React from 'react';
import { Button } from '@uhc-tempo/components';
import LocalPrintshopRoundedIcon from '@mui/icons-material/LocalPrintshopRounded';
import styles from '../../../styles/PageStyles.js';
import theme from '../../../styles/PageTheme';
const classes = styles(theme);

export default function PrintEstimateOrResultsButton(props) {
    const { style, text, handlePrint } = props;

    return (
        <Button buttonType="secondary-one" onClick={handlePrint} style={{ ...style }}>
            <LocalPrintshopRoundedIcon className={'.tds-button--secondary-one'} sx={{ mr: 0.5 }} />
            <span style={classes.printEstimateText}>{text}</span>
        </Button>
    );
}
